import { takeLatest, call, put } from 'redux-saga/effects';
import termsAndConditionsActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';
import axios from 'axios';

const {
  Types: {
    LOAD_POPUP_DETAILS_REQUEST,
    GET_TERMS_AGREEMENT_REQUEST,
    GET_POLICY_DETAILS_REQUEST,
    GET_IP_ADDRESS_REQUEST,
    UPLOAD_TERMS_DATA_REQUEST,
  },
  Creators: {
    loadPopupDetailsSuccess,
    loadPopupDetailsFailure,
    getTermsAgreementFailure,
    getTermsAgreementSuccess,
    getPolicyDetailsFailure,
    getPolicyDetailsSuccess,
    getIpAddressFailure,
    getIpAddressSuccess,
    uploadTermsDataFailure,
    uploadTermsDataSuccess,
  },
} = termsAndConditionsActions;

const {
  Creators: { setError },
} = errorActions;

function* loadPopupDetails({ caId }) {
  try {
    const { data } = yield call(dxApi.get, `/get-document-popup-details`, {
      params: {
        caId,
        isMobile: false,
      },
    });
    if (!data.success) {
      yield put(loadPopupDetailsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadPopupDetailsSuccess(data.data));
    }
  } catch (error) {
    console.log('getting popup details error');
    yield put(loadPopupDetailsFailure(error));
  }
}

function* getTermsAgreement({ caId }) {
  try {
    const { data } = yield call(dxApi.get, `/config?caid=${caId}`, {
      headers: {
        'device-os': 'web',
      },
    });
    if (localStorage.getItem('isPolkMember') === 'true') {
      localStorage.setItem('tncApiChecked', 'true');
    }
    if (!data.success) {
      yield put(getTermsAgreementFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(getTermsAgreementSuccess(data.data));
    }
  } catch (error) {
    console.log('getting terms agreement error');
    if (localStorage.getItem('isPolkMember') === 'true') {
      localStorage.setItem('tncApiChecked', 'true');
    }
    yield put(getTermsAgreementFailure(error));
  }
}

function* getPolicyDetails({ params }) {
  try {
    const { data } = yield call(dxApi.get, `/account/get-user-teams-and-condition`, {
      params,
    });
    if (!data.success) {
      yield put(getPolicyDetailsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(getPolicyDetailsSuccess(data.data));
    }
  } catch (error) {
    console.log('getting policy details error');
    yield put(getPolicyDetailsFailure(error));
  }
}

function* getIpAddress() {
  try {
    const ipifyResponse = yield call(axios.get, 'https://api.ipify.org?format=json');
    const ipAddress = ipifyResponse.data.ip;
    if (!ipAddress) {
      yield put(getIpAddressFailure('Error while getting ip address'));
      yield put(setError('Error while getting ip address'));
    } else {
      yield put(getIpAddressSuccess(ipAddress));
    }
  } catch (error) {
    console.log('Error while getting ip address');
    yield put(getIpAddressFailure(error));
  }
}

function* uploadTermsData({ payload }) {
  try {
    const { data } = yield call(
      dxApi.post,
      `/account/upload-photo/documnetsign`,
      payload,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );

    if (!data.success) {
      yield put(uploadTermsDataFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(uploadTermsDataSuccess(data));
    }
  } catch (error) {
    console.log('getting policy details error');
    yield put(uploadTermsDataFailure(error));
  }
}

export function* termsAndConditionsSaga() {
  yield takeLatest(LOAD_POPUP_DETAILS_REQUEST, loadPopupDetails);
  yield takeLatest(GET_TERMS_AGREEMENT_REQUEST, getTermsAgreement);
  yield takeLatest(GET_POLICY_DETAILS_REQUEST, getPolicyDetails);
  yield takeLatest(GET_IP_ADDRESS_REQUEST, getIpAddress);
  yield takeLatest(UPLOAD_TERMS_DATA_REQUEST, uploadTermsData);
}
